export default function($) {
  document.addEventListener('click', function(event) {
    const dropdowns = ['activity-dropdown', 'product-dropdown'];

    dropdowns.forEach(function(id) {
      const dropdown = document.getElementById(id);
      const button = event.target.closest('button');

      if (button && button.getAttribute('aria-controls') === id) {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', (!isExpanded).toString());
        return;
      }

      if (dropdown && !dropdown.contains(event.target)) {
        dropdown.classList.add('hidden');
        const trigger = document.querySelector(`[aria-controls="${id}"]`);
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });
}
